import { render, staticRenderFns } from "./BerthEditModal.vue?vue&type=template&id=39a6d044&scoped=true&"
import script from "./BerthEditModal.vue?vue&type=script&lang=js&"
export * from "./BerthEditModal.vue?vue&type=script&lang=js&"
import style1 from "./BerthEditModal.vue?vue&type=style&index=1&id=39a6d044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6d044",
  null
  
)

export default component.exports